import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AssessmentTopic } from '../../interfaces/career-setup/assessment-topic.interface';
import { PageResponse } from '../../interfaces/page-response.interface';
import { CommonSearchParam } from '../../interfaces/common-search-param.interface';
import { AssessmentTopicService } from './assessment-topic.service';

@Injectable({
  providedIn: 'root'
})
export class AssessmentTopicMockService extends AssessmentTopicService {
  private mockData: AssessmentTopic[] = [
    // Frontend Aptitude Questions
    { uniqueId: 'topic-apt-1', topic: 'What will be the output of `console.log(typeof null)`?', subTopic: 'Multiple Choice', instruction: 'Choose the correct data type returned by JS.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 2, sequenceNo: 1, active: true } as any,
    { uniqueId: 'topic-apt-2', topic: 'Which array method allows you to transform elements without mutating the original array?', subTopic: 'Multiple Choice', instruction: 'Identify the immutable transformation method.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 2, sequenceNo: 2, active: true } as any,
    { uniqueId: 'topic-apt-3', topic: 'Explain the difference between `==` and `===` operators.', subTopic: 'Subjective / Essay', instruction: 'Write a brief 50-word explanation detailing type coercion.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 5, sequenceNo: 3, active: true } as any,
    { uniqueId: 'topic-apt-4', topic: 'What is the purpose of the Event Loop in JavaScript?', subTopic: 'Multiple Choice', instruction: 'Select the description that best describes asynchronous behavior.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 3, sequenceNo: 4, active: true } as any,
    { uniqueId: 'topic-apt-5', topic: 'How does CSS Grid differ from Flexbox?', subTopic: 'Subjective / Essay', instruction: 'Discuss 1D vs 2D layout constraints.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 4, sequenceNo: 5, active: true } as any,
    { uniqueId: 'topic-apt-6', topic: 'Which keyword is used to handle exceptions in modern async/await?', subTopic: 'Multiple Choice', instruction: 'Identify the standard error handling block.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 1, sequenceNo: 6, active: true } as any,
    { uniqueId: 'topic-apt-7', topic: 'Describe what a "Closure" is in your own words.', subTopic: 'Subjective / Essay', instruction: 'Explain scope retention with a brief example.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 5, sequenceNo: 7, active: true } as any,
    { uniqueId: 'topic-apt-8', topic: 'What CSS property ensures an element is hidden but still takes up space?', subTopic: 'Multiple Choice', instruction: 'Choose between display, visibility, and opacity.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 2, sequenceNo: 8, active: true } as any,
    { uniqueId: 'topic-apt-9', topic: 'What is the Virtual DOM in React/Angular contexts?', subTopic: 'Multiple Choice', instruction: 'Select the core performance reason for its use.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 3, sequenceNo: 9, active: true } as any,
    { uniqueId: 'topic-apt-10', topic: 'Explain the concept of "Debouncing".', subTopic: 'Subjective / Essay', instruction: 'Provide a real-world frontend use case for debouncing.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 5, sequenceNo: 10, active: true } as any,
    { uniqueId: 'topic-apt-11', topic: 'What does "CORS" stand for? Why is it important?', subTopic: 'Subjective / Essay', instruction: 'Detail cross-origin security concepts.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 6, sequenceNo: 11, active: true } as any,
    { uniqueId: 'topic-apt-12', topic: 'Identify the pseudo-class used to style an element when a user hovers over it.', subTopic: 'Multiple Choice', instruction: 'Select the correct CSS syntax.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 1, sequenceNo: 12, active: true } as any,
    { uniqueId: 'topic-apt-13', topic: 'What is Semantic HTML?', subTopic: 'Multiple Choice', instruction: 'Identify its benefits for accessibility and SEO.', noOfQuestions: 1, assessmentUniqueId: 'ass-fe-apt', maxMins: 2, sequenceNo: 13, active: true } as any,
    
    // Backend Aptitude Questions
    { uniqueId: 'topic-be-1', topic: 'In REST API design, what HTTP status code indicates a resource was successfully created?', subTopic: 'Multiple Choice', instruction: 'Select the standard REST status code.', noOfQuestions: 1, assessmentUniqueId: 'ass-be-apt', maxMins: 2, sequenceNo: 1, active: true } as any,
    { uniqueId: 'topic-be-2', topic: 'Which of the following database indexes provides the fastest exact-match lookup?', subTopic: 'Multiple Choice', instruction: 'Select the correct terminology.', noOfQuestions: 1, assessmentUniqueId: 'ass-be-apt', maxMins: 2, sequenceNo: 2, active: true } as any,
    
    // Original tech stack generic topics
    { uniqueId: 'topic-1', topic: 'JavaScript Basics', instruction: 'Core JS concepts like hoisting, closures, and prototypes.', noOfQuestions: 15, assessmentUniqueId: 'ass-fe-tech', maxMins: 20, sequenceNo: 1, active: true } as any,
    { uniqueId: 'topic-2', topic: 'Angular Components', instruction: 'Component lifecycle, decorators, and metadata.', noOfQuestions: 10, assessmentUniqueId: 'ass-fe-tech', maxMins: 15, sequenceNo: 2, active: true } as any,
    { uniqueId: 'topic-3', topic: 'Dependency Injection', instruction: 'Understanding providers, injectors, and tokens.', noOfQuestions: 5, assessmentUniqueId: 'ass-fe-tech', maxMins: 10, sequenceNo: 3, active: true } as any,
  ];

  constructor() {
    super();
  }

  override findAll(params: any): Observable<PageResponse<AssessmentTopic>> {
    let filtered = [...this.mockData];
    
    if (params.assessmentUniqueId) {
      filtered = filtered.filter(t => t.assessmentUniqueId === params.assessmentUniqueId);
    }
    
    if (params.searchTerm) {
      const term = params.searchTerm.toLowerCase();
      filtered = filtered.filter(t => t.topic.toLowerCase().includes(term));
    }

    return of({
      content: filtered,
      page: {
        number: params.page || 0,
        size: params.size || 25,
        totalElements: filtered.length,
        totalPages: 1
      }
    });
  }

  override find(id: string): Observable<AssessmentTopic> {
    const item = this.mockData.find(i => i.uniqueId === id);
    return of(item as AssessmentTopic);
  }

  override create(data: Partial<AssessmentTopic>): Observable<AssessmentTopic> {
    const newItem = { ...data, uniqueId: 'mock-topic-' + Date.now() } as AssessmentTopic;
    this.mockData.push(newItem);
    return of(newItem);
  }

  override update(id: string, data: Partial<AssessmentTopic>): Observable<AssessmentTopic> {
    const index = this.mockData.findIndex(i => i.uniqueId === id);
    if (index > -1) {
      this.mockData[index] = { ...this.mockData[index], ...data };
      return of(this.mockData[index]);
    }
    return of(data as AssessmentTopic);
  }

  override updateStatus(id: string, isActive: boolean): Observable<AssessmentTopic> {
    const index = this.mockData.findIndex(i => i.uniqueId === id);
    if (index > -1) {
      this.mockData[index] = { ...this.mockData[index], active: isActive };
      return of(this.mockData[index]);
    }
    return of({ active: isActive } as AssessmentTopic);
  }

  override delete(id: string): Observable<void> {
    this.mockData = this.mockData.filter(i => i.uniqueId !== id);
    return of(undefined);
  }
}
